import React, { useEffect, useState } from 'react';
import { Wrapper, Field, ErrorLabel } from './formFields.styles';

const TextArea = ({ error, id, label, name, value, onChange, cols, rows, ...restSelectProps }) => {
  const [state, setState] = useState('');

  useEffect(() => {
    setState(value);
  }, [value]);

  useEffect(() => {
    if (label && !id) {
      throw Error('id is required when label is passed!');
    }
  }, [label, id]);

  return (
    <Wrapper>
      {label && <label htmlFor={id}>{label}</label>}
      <Field as="textarea" id={id} name={name} value={state} onChange={onChange} error={error} cols={cols} rows={rows} {...restSelectProps} />
      {error && <ErrorLabel>{`⚠ ${error}`}</ErrorLabel>}
    </Wrapper>
  );
};

export default TextArea;
